export default __webpack_public_path__ + "static/media/champagne-glasses.d83b4184.png";